import { __awaiter } from "tslib";
import { listAdapter } from './adapters';
import AjaxUtils from './ajaxUtils';
export const listsAPI = {
    getListsOfCompanies: (companyIds) => __awaiter(void 0, void 0, void 0, function* () { return AjaxUtils.post('/api/v1/companies/lists', { companyIds }); }),
    getListsOfContacts: (queryParams) => __awaiter(void 0, void 0, void 0, function* () {
        const url = `${envConfig.OUTBOUND_SEARCH_URL}/api/v1/lists?${queryParams}`;
        const results = yield AjaxUtils.get(url, true);
        return results === null || results === void 0 ? void 0 : results.lists.map(listAdapter);
    }),
    getUserTables: () => __awaiter(void 0, void 0, void 0, function* () {
        const baseQuery = 'archived=false&order=desc&orderBy=createdAt&page=0&pageSize=500&filterByViewableLists=true';
        const results = yield Promise.allSettled([
            listsAPI.getListsOfContacts(`${baseQuery}&type=contact`),
            listsAPI.getListsOfContacts(`${baseQuery}&type=company`),
        ]);
        return results.filter(result => result.status === 'fulfilled').flatMap(result => { var _a; return (_a = result.value) !== null && _a !== void 0 ? _a : []; });
    }),
    createList: (data) => __awaiter(void 0, void 0, void 0, function* () { return AjaxUtils.post('/api/v1/lists', data); }),
};
